/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bills: NonNullable<unknown>, customers: NonNullable<unknown> }} Admin_Export_Erp_SummaryInputs */



/**
* | output |
* | --- |
* | "{bills} bills · {customers} customers" |
*
* @param {Admin_Export_Erp_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_erp_summary = /** @type {((inputs: Admin_Export_Erp_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Erp_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.bills} Rechnungen · ${i?.customers} Kunden`)
	return /** @type {LocalizedString} */ (`${i?.bills} bills · ${i?.customers} customers`)
});